/**
 * Drop a blank "iOS image URL" before saving. The backend validates imgurlIos like
 * imgurl, so an empty string would be rejected; leaving the key out also clears a
 * value saved earlier, because the whole config is replaced on save.
 */
export function cleanIosImage<T extends object>(ad: T): T {
  const { imgurlIos, ...rest } = ad as Record<string, unknown>;
  const trimmed = typeof imgurlIos === 'string' ? imgurlIos.trim() : '';
  return (trimmed ? { ...rest, imgurlIos: trimmed } : rest) as T;
}
